import { Box, Flex } from "@chakra-ui/layout"
import { useRecoilValue } from "recoil"

import { MODAL_Z_INDEX } from "../../../../constants"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { productPageOverlaySelector } from "../../../../recoil/atoms/product-overlay"
import { blendWithWhiteBackground } from "../../../../util"
import { PRODUCT_DESTINATION } from "../../../../constants/enums"

function ProductPageOverlay() {
  const productPageOnOverlay = useRecoilValue(productPageOverlaySelector)
  const roomStyles = useRecoilValue(brandingSelector)

  if (
    !productPageOnOverlay.isOpen ||
    !productPageOnOverlay.url ||
    productPageOnOverlay.location !== PRODUCT_DESTINATION.LIVESELL_IFRAME
  )
    return null

  return (
    <Box
      width="100vw"
      height="100vh"
      position="fixed"
      background="white"
      zIndex={MODAL_Z_INDEX}
      top="0"
      left="0"
      backgroundColor="rgba(255, 255, 255, 0.5)"
    >
      <Flex
        width="100vw"
        height="100vh"
        bg={
          blendWithWhiteBackground(
            roomStyles.servicePanelElementModalBackground
          ) ?? "white"
        }
        color={roomStyles?.servicePanelElementPrimaryText}
      >
        <iframe
          height="100%"
          width="100%"
          src={productPageOnOverlay.url}
          title="Product Checkout Page"
        />
      </Flex>
    </Box>
  )
}

export default ProductPageOverlay
